/* ============================================================================
   ZAHRUN — PREMIUM MOTION SYSTEM  ·  Impulse 7.1.0
   Lightweight, dependency-free. Scroll-reveal + stagger, magnetic buttons,
   subtle card tilt, and skeleton-to-content handoff. Fully respects
   prefers-reduced-motion and the theme's data-disable-animations flag.
   Does not touch cart/checkout/variant logic.
   ============================================================================ */
(function () {
  "use strict";

  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var themeOff = document.body && document.body.getAttribute("data-disable-animations") === "true";
  var motionOK = !reduce && !themeOff;

  /* ---- Scroll reveal + stagger (runs even if motion reduced: just shows) ---- */
  var revealSel = [
    ".section-header", ".grid-product", ".rte",
    ".promo-grid__item", ".text-with-icons__item",
    ".featured-collection", ".testimonials-slider",
    "[data-zx-reveal]", "[data-zx-stagger]"
  ].join(",");

  function reveal() {
    var nodes = document.querySelectorAll(revealSel);
    if (!("IntersectionObserver" in window) || !motionOK) {
      nodes.forEach(function (n) { n.classList.add("zx-in"); });
      return;
    }
    nodes.forEach(function (n) {
      if (!n.hasAttribute("data-zx-reveal") && !n.hasAttribute("data-zx-stagger")) {
        n.setAttribute("data-zx-reveal", "");
      }
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        if (el.hasAttribute("data-zx-stagger")) {
          Array.prototype.forEach.call(el.children, function (c, i) {
            c.style.transitionDelay = (i * 70) + "ms";
          });
        }
        el.classList.add("zx-in");
        io.unobserve(el);
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.05 });
    nodes.forEach(function (n) { io.observe(n); });
  }

  /* ---- Magnetic buttons ---- */
  function magnetic() {
    if (!motionOK || window.matchMedia("(pointer: coarse)").matches) return;
    var btns = document.querySelectorAll(".btn, [data-zx-magnetic]");
    btns.forEach(function (btn) {
      btn.addEventListener("mousemove", function (ev) {
        var r = btn.getBoundingClientRect();
        var mx = (ev.clientX - r.left - r.width / 2) * 0.18;
        var my = (ev.clientY - r.top - r.height / 2) * 0.28;
        btn.style.setProperty("--mx", mx.toFixed(1) + "px");
        btn.style.setProperty("--my", my.toFixed(1) + "px");
      });
      btn.addEventListener("mouseleave", function () {
        btn.style.setProperty("--mx", "0px");
        btn.style.setProperty("--my", "0px");
      });
    });
  }

  /* ---- Subtle 3D tilt on elements opted in with [data-zx-tilt] ---- */
  function tilt() {
    if (!motionOK || window.matchMedia("(pointer: coarse)").matches) return;
    document.querySelectorAll("[data-zx-tilt]").forEach(function (el) {
      el.addEventListener("mousemove", function (ev) {
        var r = el.getBoundingClientRect();
        var px = (ev.clientX - r.left) / r.width - 0.5;
        var py = (ev.clientY - r.top) / r.height - 0.5;
        el.style.transform = "perspective(800px) rotateY(" + (px * 6).toFixed(2) + "deg) rotateX(" + (-py * 6).toFixed(2) + "deg)";
      });
      el.addEventListener("mouseleave", function () { el.style.transform = ""; });
    });
  }

  /* ---- Skeleton handoff: reveal [data-zx-skeleton-for] once images load ---- */
  function skeleton() {
    document.querySelectorAll("[data-zx-skeleton]").forEach(function (box) {
      var imgs = box.querySelectorAll("img");
      if (!imgs.length) { box.classList.remove("zx-skeleton"); return; }
      var left = imgs.length;
      imgs.forEach(function (img) {
        if (img.complete) { if (--left === 0) box.classList.remove("zx-skeleton"); }
        else img.addEventListener("load", function () { if (--left === 0) box.classList.remove("zx-skeleton"); });
      });
    });
  }

  function init() { reveal(); magnetic(); tilt(); skeleton(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
